import Vue from 'vue'
import Router from 'vue-router'
import Mindex from '@/components/m/Index'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Default',
      redirect: '/pc'
    },
    {
      path: '/m',
      name: 'Mindex',
      component: Mindex
    },
    {
      path: '/base',
      name: 'PcBase',
      component: () => import('@/components/pc/Base'),
      children: [
        {
          path: '/pc',
          name: 'Pcindex',
          component: () => import('@/components/pc/Index'),
        },
        {
          path: '/pc/about',
          name: 'Pcabout',
          component: () => import('@/components/pc/About'),
        },
        {
          path: '/pc/hot',
          name: 'Pchot',
          component: () => import('@/components/pc/Hot'),
        },
        {
          path: '/pc/demand',
          name: 'Pcdemand',
          component: () => import('@/components/pc/Demand'),
        },
        {
          path: '/pc/we',
          name: 'Pcwe',
          component: () => import('@/components/pc/We'),
        },
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js